module.exports = __webpack_public_path__ + "img/ico-walletlist-remittance.b9018285.svg";